import React from "react";
import FromHome from "./FromHome";
import ServicesHead from "../MainServices/ServiceHead";

const MainFromHome = () => {
  return (
    <div>
      <ServicesHead />
      <FromHome />
    </div>
  );
};

export default MainFromHome;
